import type { Role } from '.'

export const EMPTY_ROLE_SETTINGS: Role = {
  id: null,
  name: '',
  description: '',
  permissions: {
    access_api_key: false,
    access_audit_logs: false,
    delete_responses: false,
    edit_ratings_on_responses: false,
    edit_tags_on_responses: false,
    edit_team_members_on_responses: false,
    edit_topics_on_responses: false,
    export_customers: false,
    publish_feedback: false,
    manage_account_settings: false,
    manage_authentication_security: false,
    manage_billing_information: false,
    manage_brands: false,
    manage_custom_dashboards: false,
    manage_customers: false,
    manage_dashboard_views: false,
    manage_email_authentication: false,
    manage_feedback_scheduled_reports: false,
    manage_feedback_views: false,
    manage_feedback_widgets: false,
    manage_integrations: false,
    manage_reports_scheduled_reports: false,
    manage_reports_views: false,
    manage_surveys: false,
    manage_topic_settings: false,
    manage_user_access_to_surveys: false,
    manage_users: false,
    view_billing_page: 'no_access',
    view_custom_dashboards: 'restricted_per_role',
    view_customers: 'all',
    view_team_members: 'no_access',
    manage_team_members: false,
    view_feedback: 'survey_access',
    view_reports: 'all',
    view_survey_dashboards: 'all',
    view_surveys_page: 'restricted_per_role',
  },
  survey_access: [],
  dashboard_access: [],
}



// WEBPACK FOOTER //
// ./src/components/CustomRoleForm/constants.tsx